import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { GoBackButtonWithTitle, PageHeaderBoldTitle, PageWrapper, Spinner } from 'components';
import { useCreateDraft } from 'hooks';

import { CreatePollForm } from '../../components';
import { defaultValuesAdapter } from './adapter';
import { ContentW, FormW } from './styled';

export function CreatePollPage(): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { draft, isLoading: isDraftLoading } = useCreateDraft();

  if (isDraftLoading) {
    return <Spinner />;
  }
  return (
    <PageWrapper>
      <GoBackButtonWithTitle
        title={t('common.back')}
        onClick={() => navigate(-1)}
        containerSx={{
          marginTop: 0,
          maxWidth: '100%',
        }}
      />
      <PageHeaderBoldTitle title={t('poll.create.title')} />
      <ContentW>
        <FormW>
          <CreatePollForm draft={draft} defaultValues={defaultValuesAdapter} />
        </FormW>
      </ContentW>
    </PageWrapper>
  );
}
